import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/esm/applyDecoratedDescriptor";
var _dec, _dec2, _dec3, _class;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import { List, Map } from 'immutable';
import { rule } from 'instructure-validations';
import { presenceMessage } from '@instructure/quiz-interactions';
import t from '@instructure/quiz-i18n/format-message';
import QuizAnalysis from './QuizAnalysis';
import ReduxRecord from './reduxRecord';
import withStateCache from '../util/withStateCache';
import { getQuizSessionById } from '../selectors/quizSessions';
import { getQuizEntriesByIds } from '../selectors/quizzes';
import { getLatestQtiImportForParentWithType } from '../selectors/qtiImports';
import { getItemAnalysesByIds } from '../selectors/reporting';
export var Quiz = (_dec = withStateCache(function (quiz) {
  return [['quizEntries'], ['modifications', 'quizEntries']];
}), _dec2 = withStateCache(function (quiz) {
  return [['quizEntries'], ['modifications', 'quizEntries'], ['modifications', 'quizzes', quiz.id, 'quizEntries']];
}), _dec3 = withStateCache(function (quiz) {
  return [['modifications', 'quizzes']];
}), _class = /*#__PURE__*/function (_ReduxRecord) {
  function Quiz() {
    _classCallCheck(this, Quiz);
    return _callSuper(this, Quiz, arguments);
  }
  _inherits(Quiz, _ReduxRecord);
  return _createClass(Quiz, [{
    key: "getTimeLimit",
    value: function getTimeLimit() {
      return this.hasTimeLimit ? this.sessionTimeLimitInSeconds : 0;
    }
  }, {
    key: "getQuizSessions",
    value: function getQuizSessions() {
      var _this2 = this;
      return this.getState().get('quizSessions').filter(function (data) {
        return data.get('quiz') === _this2.id;
      }).map(function (qsd) {
        return getQuizSessionById(_this2.getState(), qsd.get('id'));
      }).valueSeq().toList();
    }
  }, {
    key: "getQuizSessionsForUser",
    value: function getQuizSessionsForUser(userId) {
      return this.getQuizSessions().filter(function (quizSession) {
        return quizSession.getIn(['user', 'id']) === userId;
      });
    }
  }, {
    key: "getQuizEntries",
    value: function getQuizEntries() {
      return getQuizEntriesByIds(this.getState(), this.quizEntries).sortBy(function (qe) {
        return qe.position;
      });
    }
  }, {
    key: "hasQuestions",
    value: function hasQuestions() {
      return this.getQuizEntries().some(function (qe) {
        return !qe.hasStimulus;
      });
    }
  }, {
    key: "getItemAnalyses",
    value: function getItemAnalyses() {
      // TODO: Sort this based on the ordering on the quiz build page
      return getItemAnalysesByIds(this.getState(), this.itemAnalyses);
    }
  }, {
    key: "getQuizAnalysis",
    value: function getQuizAnalysis() {
      return new QuizAnalysis(this.getState().getIn(['reporting', 'quiz_analysis', this.quizAnalysis]));
    }

    // If you call this.getWorkingInstance().getQuizEntries() manually, then
    // changes to the other parts of a quiz (e.g., changing the title) will
    // invalidate the cache, since the result of getWorkingInstance() will
    // be a new object. This method explicitly caches by only the fields that are
    // relevant to the working quiz entries.
  }, {
    key: "getWorkingQuizEntries",
    value: function getWorkingQuizEntries() {
      return this.getWorkingInstance().getQuizEntries();
    }
  }, {
    key: "getWorkingInstance",
    value: function getWorkingInstance() {
      var _this3 = this;
      var modData = this.getState().getIn(['modifications', 'quizzes', this.id]) || Map();
      var data = this.merge(modData.update('quizEntries', List(),
      // default
      function (qi) {
        // without custom merge, quizEntries List will be
        // overwritten completely, and wouldnt' support
        // temporary quizEntry associations well
        return qi.concat(_this3.quizEntries.toJS());
      }));
      return Quiz.create(data, this.getState());
    }
  }, {
    key: "getLatestImport",
    value: function getLatestImport() {
      return getLatestQtiImportForParentWithType(this.getState(), this.id, 'Quiz');
    }
  }, {
    key: "isLoaded",
    value: function isLoaded() {
      return this.id !== '0';
    }
  }, {
    key: "isImporting",
    value: function isImporting() {
      return this.status === 'importing';
    }
  }, {
    key: "canImport",
    value: function canImport() {
      // associating the quizEntry will change the quiz status in the
      // db but it wont return this info, we we'll check the quizEntry
      // count in addition to the status
      return this.status === 'uninitialized' && this.quizEntries.size === 0;
    }
  }, {
    key: "isOneQuestionAtATime",
    value: function isOneQuestionAtATime() {
      return this.oneAtATimeType === 'question';
    }
  }, {
    key: "state",
    value: function state() {
      return this.getState();
    }
  }], [{
    key: "validations",
    value: function validations() {
      return {
        title: [rule('presence', {
          message: presenceMessage(t('Quiz title'))
        })]
      };
    }
  }]);
}(ReduxRecord({
  allowBacktracking: true,
  allowClearMcSelection: false,
  calculatorType: 'none',
  choiceElimination: false,
  contextId: null,
  defaultRceSettings: null,
  detectMultipleSessions: false,
  disableDocumentAccess: false,
  hasTimeLimit: false,
  id: '0',
  instructions: t('Add Instructions...'),
  itemAnalyses: List(),
  items: List(),
  oneAtATimeType: null,
  originalQuizLockedByBlueprint: true,
  outcomeAlignmentSetGuid: null,
  owner: null,
  quizAnalysis: '0',
  quizEntries: List(),
  quizEntriesCount: 0,
  requireStudentAccessCode: false,
  resultsFeedback: null,
  resultsFeedbackEnabled: false,
  sessionTimeLimitInSeconds: null,
  shuffleAnswers: false,
  shuffleQuestions: false,
  status: null,
  studentAccessCode: null,
  title: t('Add Title...'),
  filterIpAddress: false,
  filters: Map(),
  valid: true
})), _applyDecoratedDescriptor(_class.prototype, "getQuizEntries", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "getQuizEntries"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getWorkingQuizEntries", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "getWorkingQuizEntries"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getWorkingInstance", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "getWorkingInstance"), _class.prototype), _class);
export default Quiz;